<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row g-0 m-0 d-flex pt-5 align-items-center">
      <div class="col-md-1 d-flex pe-4 justify-content-end">
        <div class="button-back pb-1" [routerLink]="['/on-demand/custom-register']">
          <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
        </div>
      </div>
      <div class="col-md-6">
        <h2 class="col pb-2 m-0 title">
          {{ "CUSTOM_REGISTER_DATA" | translate }} {{ "DETAILS" | translate }}
        </h2>
        <h6 class="col subtitle">
          {{ "ONDEMANDCUSTOMREG_SUBTITLE" | translate }}
        </h6>
      </div>
    </div>
    <div class="row g-0 m-0 pt-3">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" /><span>{{
                "INGESTIONTIME" | translate | uppercase
                }}</span>
            </th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" /><span>{{
                "READTIME" | translate | uppercase
                }}</span>
            </th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" /><span>{{
                "ENERGYREGISTERS_METERNO" | translate | uppercase
                }}</span>
            </th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" /><span>{{
                "REGISTERNAME" | translate | uppercase
                }}</span>
            </th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" /><span>{{
                "OBIS_CODE" | translate | uppercase
                }}</span>
            </th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" /><span>{{
                "REGISTERVALUE" | translate | uppercase
                }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of data; let i=index">
            <td></td>
            <td>
              <span>{{ item.ingestionTime | date: "dd MMM yy, h:mm:ss" }}</span>
            </td>
            <td>
              <span>{{ item.meterTime | date: "dd MMM yy, h:mm:ss" }}</span>
            </td>
            <td>
              <span (click)="clipboardService.copyToClipboard(item.meterNumber!, $event, i)" class="copyable">
                {{ item.meterNumber }}
                <span class="copy-tooltip" *ngIf="clipboardService.copiedText === i.toString()">{{"COPIED" |
                  translate}}</span>
              </span>
            </td>
            <td>
              <span>{{ item.attributeName }}</span>
            </td>
            <td>
              <span>{{ item.obis }}</span>
            </td>
            <td>
              @if (
              item.stringValue !== null ||
              item.doubleValue !== null) {
                <span [title]="(item.unit) ? (item.doubleValue ?? 0) + ' ' + item.unit : ' '">
                {{ item.stringValue  ?? ((item.unit && (item.doubleValue ?? 0) > 1000)
                  ? ((item.doubleValue ?? 0) | unitConverter: item.unit)
                  : (item.doubleValue ?? 0) + ' ' + item.unit)}}
              </span>}
              @else if (item.errorMessage) {
                <span
                  class="text-wrapper"
                  [ngClass]="'status-failed'"
                  [title]="getErrorMessage(item.errorMessage)"
                  (click)="copyErrorMessage(item.errorMessage)"
                >
                  {{ "ERROR" | translate | uppercase }}
                </span>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="container-down">
      <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfRegisters" [pageSize]="pageSize"
        [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
    </div>
  </div>
</div>
